module.exports = __webpack_public_path__ + "img/StaffStyle1.de23ff28.png";